import commonService from "./common-service";

class UpdateEOMDataService {

    async uploadUpdateEOMDocument(year, month, params) {
        try {
            const response = await commonService.postToServer(
                "EOM/Updates/Upload?" + 'year=' + year + '&month=' + month,
                params
            );
            if (response) {
                return response;
            } else {
                throw new Error("Error uploading document");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async fetchErrorEOMData(year, month) {
        try {
            const response = await commonService.postToServer(
                "EOM/Updates/Errors?" + 'year=' + year + '&month=' + month
            );
            if (response) {
                return response;
            } else {
                throw new Error("Error while fetching EOM Data");
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async deleteErrorsById(id) {
        try {
            const response = await commonService.deleteToServer(
                "EOM/Updates/" + id,
                {}
            );
            return response;
        } catch (e) {
            throw new Error("Error in deleting EOM Error");
        }
    }

    async updateEOMErrors(year, month) {
        try {
            let response = await commonService.updateToServer(
                "EOM/Updates?" + 'year=' + year + '&month=' + month,
            );

            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async getEOMErrosDocument(year, month) {
        try {
            await commonService.downloadFromServer(
                "EOM/Updates/Errors?" + 'year=' + year + '&month=' + month,
                {
                    fileName: "EOM_Err_UPDATES.xlsx",
                }
            );
        } catch (e) {
            throw new Error(e.message);
        }
    }
}

export default new UpdateEOMDataService();
